import { render } from "./FormAlan.vue?vue&type=template&id=62ee31bb"
import script from "./FormAlan.vue?vue&type=script&lang=js"
export * from "./FormAlan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__